import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  q: '¿Esto sirve si nunca me preparé antes?',
  a: 'Sí. El sistema está pensado para personas comunes y hogares reales. Todo está explicado de forma simple y práctica.'
}, {
  q: '¿Funciona en Argentina?',
  a: '¡Sí! Todo el contenido está pensado para contexto argentino y latinoamericano.'
}, {
  q: '¿Necesito experiencia previa?',
  a: 'No. El sistema está diseñado para principiantes y familias comunes.'
}, {
  q: '¿Qué pasa si no me gusta?',
  a: 'Tenés garantía total de 7 días. Si sentís que el material no es para vos, nos enviás un correo y te devolvemos el 100% de tu dinero sin preguntas.'
}, {
  q: '¿Es digital o físico?',
  a: 'Es 100% digital y descargable. Recibís acceso inmediato a todo el material en formato PDF de alta calidad.'
}, {
  q: '¿Cómo accedo al material?',
  a: 'Inmediatamente después de tu compra, recibís un correo electrónico con tus datos de acceso para descargar todo el contenido.'
}];
export function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="bg-brand-dark py-5 px-5" data-id="element-101">
      <div className="max-w-xl mx-auto" data-id="element-102">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-8" data-id="element-103">
          ❓ Preguntas Frecuentes
        </h2>

        <div className="space-y-3" data-id="element-104">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl overflow-hidden transition-all" data-id="element-105">
              <button className="w-full px-5 py-4 text-left flex justify-between items-center hover:bg-white/10 focus:outline-none transition-colors" onClick={() => setOpenIdx(openIdx === idx ? null : idx)} data-id="element-106">
                <span className="font-bold text-white text-sm pr-4" data-id="element-107">
                  {faq.q}
                </span>
                {openIdx === idx ? <ChevronUp className="text-brand-yellow flex-shrink-0" size={18} data-id="element-108" /> : <ChevronDown className="text-gray-600 flex-shrink-0" size={18} data-id="element-109" />}
              </button>
              {openIdx === idx && <div className="px-5 pb-4 text-sm text-gray-400 leading-relaxed border-t border-gray-800" data-id="element-110">
                  <div className="pt-3" data-id="element-111">{faq.a}</div>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}